import { render, staticRenderFns } from "./PuzzleFencesForm.vue?vue&type=template&id=b4706c0c&"
import script from "./PuzzleFencesForm.vue?vue&type=script&lang=js&"
export * from "./PuzzleFencesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports